<div *ngIf="router.url =='/main/edit-data'" class="">
  <form [formGroup]="addForm">
    <div (click)="showWindow = !showWindow" *ngIf="showWindow" class="w-full h-screen bg-black top-0 left-0 z-20 bg-opacity-25 fixed"></div>
    <div *ngIf="showWindow" class="text-center border-2 p-4 top-0 h-auto left-0 z-20 modalWindow fixed z-30 w-1/3 bg-white">
      <div class="text-3xl"> {{ 'Добавление ВУЗа' | translate }}</div>
      <div class="my-2 ">
        <div class="my-2 ">
          <div class="my-2">
            <label class="mr-3"> {{ 'Область' | translate }} </label>
            <select formControlName="oblId" class="rounded-lg border-2 mr-20 flex-grow w-full px-3"
                    [ngClass]="{'is-invalid': addForm.get('oblId')?.invalid && (addForm.get('oblId')?.touched)}">
              <option [value]="null" disabled selected> {{ 'Область' | translate }} </option>
              <option *ngFor="let item of addOblList" [value]="item.id">
                <span *ngIf="translate.currentLang == 'kz'"> {{ item.nameKaz }} </span>
                <span *ngIf="translate.currentLang == 'ru'"> {{ item.nameRus }} </span>
              </option>
            </select>
            <div *ngIf="addForm.get('oblId')?.invalid && (addForm.get('oblId')?.touched)" class="text-red-500 text-sm">
              {{ 'Поле обязательно для заполнения' | translate }}
            </div>
          </div>
          <div>
            <label class="mr-3"> {{ 'Код вуза' | translate }} </label>
            <input formControlName="code" type="number" class="rounded-lg border-2 mr-20 w-full px-2"
                   [ngClass]="{'is-invalid': addForm.get('code')?.invalid && (addForm.get('code')?.touched)}">
            <div *ngIf="addForm.get('code')?.invalid && (addForm.get('code')?.touched)" class="text-red-500 text-sm">
              {{ 'Поле обязательно для заполнения' | translate }}
            </div>
          </div>
          <div>
            <label class="mr-3"> {{ 'Наименование на казахском' | translate }} </label>
            <input formControlName="nameKaz" type="text" class="rounded-lg border-2 mr-20 w-full px-2"
                   [ngClass]="{'is-invalid': addForm.get('nameKaz')?.invalid && (addForm.get('nameKaz')?.touched)}">
            <div *ngIf="addForm.get('nameKaz')?.invalid && (addForm.get('nameKaz')?.touched)" class="text-red-500 text-sm">
              {{ 'Поле обязательно для заполнения' | translate }}
            </div>
          </div>
          <div class="mк-3">
            <label class="mr-3"> {{ 'Наименование на русском' | translate }} </label>
            <input formControlName="nameRus" type="text" class="rounded-lg border-2 mr-20 w-full px-2"
                   [ngClass]="{'is-invalid': addForm.get('nameRus')?.invalid && (addForm.get('nameRus')?.touched)}">
            <div *ngIf="addForm.get('nameRus')?.invalid && (addForm.get('nameRus')?.touched)" class="text-red-500 text-sm">
              {{ 'Поле обязательно для заполнения' | translate }}
            </div>
          </div>
          <div class="flex mt-5">
            <label>
              Отображать в списке при подаче заявок
            </label>
            <input class="ml-4 mt-1" style="width: 15px; height: 15px" formControlName="isEnabled" type="checkbox" >
          </div>
        </div>
      </div>

      <div class="flex">
        <div class="w-1/2">
          <button (click)="setInstitute()" class="w-56 my-10 rounded-lg btn text-center btn-outline-primary text-white btn-lg btn-block bg-blue-400 p-1">
            {{ 'Добавить' | translate }}
          </button>
        </div>

        <div class="w-1/2">
          <button (click)="closeWindow()" class="w-56 my-10 rounded-lg btn bg-red-400 text-center text-white btn-outline-primary btn-lg btn-block p-1">
            {{ 'Отмена' | translate }}
          </button>
        </div>
      </div>
    </div>
  </form>
  <div class="flex w-full" style="width: 125%; position: fixed">
    <div class="w-4/6 h-full shadow-md bg-white rounded-lg">
<!--      <div class="flex mb-6">-->
<!--        <div class="flex items-center w-full h-20 border-2 px-14 bg-gray-50 rounded-md">-->
<!--          <div class="flex items-center ml-2">-->
<!--            <button class="bg-blue-300 border-blue-300 p-2 w-36 border-2 rounded-lg">-->
<!--              Vuz-->
<!--            </button>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
      <div class="text-gray-900 bg-gray-200 p-4 rounded-lg shadow-md">
        <div class="my-2 flex">
          <label class="mr-3"> {{ 'Область' | translate }} </label>
          <select (change)="getInstitute()" [(ngModel)]="oblId" [ngModelOptions]="{standalone: true}" class="rounded-lg border-2 mr-20 flex-grow w-full px-3">
            <option [value]="0" disabled selected> {{ 'Stream' | translate }} </option>
            <option *ngFor="let item of oblList" [value]="item.id">
              <span *ngIf="translate.currentLang == 'kz'"> {{ item.nameKaz }} </span>
              <span *ngIf="translate.currentLang == 'ru'"> {{ item.nameRus }} </span>
            </option>
          </select>
          <button (click)="openWindow()" class="w-full py-1 bg-blue-300 rounded-lg text-grey-darker">
            Добавить ВУЗ
          </button>
        </div>
      </div>
      <div class="mt-6 bg-white w-auto m-auto p-4 shadow-md rounded-lg">
        <table class="min-w-full text-left border-collapse table-fixed">
          <thead>
          <tr>
            <th class="px-14 py-3 border border-slate-600 text-sm leading-4 text-gray-500"> Код </th>
            <th class="px-14 py-3 border border-slate-600 text-sm leading-4 text-gray-500"> Наименование учебного учреждения каз </th>
            <th class="px-14 py-3 border border-slate-600 text-sm leading-4 text-gray-500"> Наименование учебного учреждения рус </th>
            <th class="px-14 py-3 border border-slate-600 text-sm leading-4 text-gray-500"> Действия </th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let inst of instituteList; index as i" class="hover:bg-gray-100 transition">
            <td class="border border-slate-700 px-4 py-2">
              <span> {{ inst.id }} </span>
            </td>
            <td class="border border-slate-700 px-4 py-2">
              <span> {{ inst.nameKaz }} </span>
            </td>
            <td class="border border-slate-700 px-4 py-2">
              <span> {{ inst.nameRus }} </span>
            </td>
            <td class="border border-slate-700 px-4 py-2">
              <button class="w-full py-1 bg-blue-300 rounded-lg text-grey-darker" [routerLink]="['/main/edit-data/vuz-data/' + inst.id]" [queryParams]="{ id: inst.id }">
                {{ 'Edit' | translate }}
              </button>
            </td>
          </tr>
          </tbody>
        </table>
        <hr class="mt-6">
      </div>
    </div>
  </div>
</div>
<router-outlet></router-outlet>
